const CONFIG = {
  API_URL: 'https://kalpanax-api.kalbeconsumerhealth.com/api/v1',
  Domain_URL: 'https://bebasjamur.kalbeconsumerhealth.com'
};

export default CONFIG;
